import * as React from 'react';
import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import { ISinglePro } from '../../../../components/singlePro/state';
import { DirectUpload } from '../../../profile/MyIntroVideos';
import Label from './Label';
import { IconCamera } from '../../../../utils/icons';

interface ICommonProps {
  keyName: string;
  user?: ISinglePro;
}

interface ISingleVideo extends ICommonProps {
  title: string;
  onChange?: Function;
}
export const SingleVideo: React.FC<ISingleVideo> = ({
  keyName,
  user,
  title,
  onChange,
}) => {
  // @ts-ignore
  const [videoUrl, setVideoUrl] = React.useState(user?.[keyName] || '');
  const [showVideo, setShowVideo] = React.useState(true);

  const onVideoComplete = (url: string) => {
    setVideoUrl(url);
    setShowVideo(false);
    onChange?.(url);
  };

  if (!user && !showVideo) return <div />;
  return (
    <Box className="flex flex-col gap-2">
      <Typography sx={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
        <Label text={title} />{' '}
        <span className="text-xs ">( Recomended: 20-30 sec. 1920x1080 / 1080x1920 .mp4 )</span>
      </Typography>
      <Box className="flex gap-3 sm:gap-6 items-stretch sm:items-center flex-col sm:flex-row">
        <Box
          className={classNames(
            'flex items-center justify-center rounded-lg shrink-0 w-full sm:w-[207px] h-[180px] sm:h-[124px]',
            {
              'bg-black': videoUrl,
              'bg-tint': !videoUrl,
            },
          )}
        >
          {videoUrl ? (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video className="w-full h-full rounded-lg" controls controlsList="nodownload">
              <source src={videoUrl} type="video/webm" />
            </video>
          ) : (
            <IconCamera />
          )}
        </Box>
        <Box
          display="flex"
          alignItems="center"
          position="relative"
          gap={1.5}
          justifyContent="space-between"
        >
          <DirectUpload
            variant="contained"
            keyName={keyName}
            onComplete={onVideoComplete}
          />
        </Box>
      </Box>
    </Box>
  );
};
